import API from "@/api/modules/clueTeacherForm";
const COS = require("cos-js-sdk-v5");
import { Toast } from "vant";

export default class uploadbase64Img {
  constructor() {
    this.defaultKey = "";
    this.Region = "ap-beijing";
    this.Bucket = "";
    this.keyName = "";
    this.url = "";
  }
  async createOssClient() {
    let data = {};
    try {
      const response = await API.getImageCredential({ type: 0 });
      data = response.data;
      console.log('-----data-----', data);
      if (!response.ret) {
        Toast("获取oss资源失败");
        return false;
      }
    } catch (e) {
      Toast("获取oss资源失败");
      console.log(e);
      return false;
    }

    const { credentials } = data;
    const ID = credentials.tmpSecretId;
    const SECRET = credentials.tmpSecretKey;
    const TOKEN = credentials.sessionToken;
    this.Bucket = data.bucketName;
    this.defaultKey = data.bucketName;
    this.keyName = data.keyName;
    this.url = data.url;
    const upClient = new COS({
      getAuthorization(options, callback) {
        console.log("util getAuthorization options: ", options);
        callback({
          TmpSecretId: ID,
          TmpSecretKey: SECRET,
          SecurityToken: TOKEN,
          ExpiredTime: data.expiredTime,
        });
      },
    });
    console.log('-----upClientupClien-------t', upClient);
    return upClient;
  }
  // base64转文件
  base64ToBlob(code, type) {
    let parts = code.split(";base64,");
    let contentType = parts[0].split(":")[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;

    let uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    if (type === "blob") {
      return new Blob([uInt8Array], { type: contentType });
    }
    return new File([uInt8Array], "img", { type: contentType });
  }
  // 上传图片
  upload(baseImg) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      const upClient = await this.createOssClient();
      console.log('-----upClientupClient', upClient);
      let imageUrl = "";
      let imgBlob = this.base64ToBlob(baseImg);
      try {
        let ossUrl = "";
        const uploadFile = {
          Bucket: this.Bucket,
          Region: this.Region,
          Key: `${this.keyName}.jpg`,
          Body: imgBlob,
        };
        upClient.uploadFile(
          {
            ...uploadFile,
          },
          (err, data) => {
            if (err) {
              throw new Error(err);
            }
            const { Location = "" } = data;
            ossUrl = `https://${Location}`;
            imageUrl = this.changeOssUrl(ossUrl);
            resolve(imageUrl);
          }
        );
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  }
  changeOssUrl(url) {
    return url.replace("http://", "https://");
  }
}
